import {
  isGlobalErrorPageStatus,
  normalizeContainerErrorStatus,
} from '../utils/network/normalize-container-error-status';

export function shouldSuppressGlobalErrorToast(error: unknown): boolean {
  return isGlobalErrorPageStatus(normalizeContainerErrorStatus(error));
}
